import { FilterConfigStatic } from '@/types/filter';
import { Filter } from '@cubejs-client/core';
import { FilterValue } from '@/models';
import { PARTNERSCORE_CUBE_NAME } from '@/api/hcp';
import { buildRangeMultiselectFilter } from './utils';

const TRUST_REPUTATION_MEMBER = `${PARTNERSCORE_CUBE_NAME}.trans_q3_trust_and_reputation`;

const NO_DATA_VALUE = '-';

const trustReputationFilter: FilterConfigStatic = {
  label: 'global.filters.formControls.trustReputationLabel',

  options: [
    { value: '100', label: 'Always' },
    { value: '75-99', label: 'Usually' },
    { value: '50-74', label: 'Sometimes' },
    { value: '25-49', label: 'Rarely' },
    { value: '0-24', label: 'Never' },
    { value: NO_DATA_VALUE, label: 'No data available' },
  ],

  defaultValue: [],
  type: 'multiselect',
  searchable: true,
  clearable: true,
  placeholder: 'global.filters.formControls.trustReputationPlaceholder',

  applyFilter: (filterValue: FilterValue): Filter | undefined =>
    buildRangeMultiselectFilter(TRUST_REPUTATION_MEMBER, filterValue, NO_DATA_VALUE),
};

export default trustReputationFilter;
